import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { CheckIcon, DropdownIcon, UserIcon } from "app/components/Icons";
import completed_icon from "assets/Sprints/Frame 1000007478.png";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSafeFormattedDate, getWeekDifference } from "../../helper";
import { selectCompletedSprintList } from "../../redux/selector";
import { actions } from "../../redux/slice";
import { ISprintList } from "../../types";

interface Props {
  selectedSprint: string;
}
const SelectSprint: React.FC<Props> = ({ selectedSprint }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);
  const sprintList = useSelector(selectCompletedSprintList);
  const dispatch = useDispatch();
  const [selectedSprints, setSelectedSprints] = useState<ISprintList>(
    sprintList[0]
  );

  useEffect(() => {
    if (containerRef.current) {
      setDropdownWidth(containerRef.current.offsetWidth);
    }
  }, []);
  const onChangeDefault = () => {
    dispatch(actions.setSprintMembers([]));
    dispatch(
      actions.updateFormValue({
        key: "selectedSprint",
        value: "",
      })
    );
    dispatch(
      actions.updateFormValue({
        key: "scrumMasterId",
        value: "",
      })
    );
    dispatch(
      actions.updateFormValue({
        key: "startDate",
        value: "",
      })
    );
    dispatch(actions.updateFormValue({ key: "endDate", value: "" }));
  };
  const onChange = (value: string) => {
    dispatch(actions.updateFormValue({ key: "selectedSprint", value: value }));

    const selectedSprint = sprintList.find((x) => x._id === value);
    setSelectedSprints(selectedSprint as ISprintList);
    dispatch(actions.setSprintMembers(selectedSprint?.members as string[]));
    dispatch(
      actions.updateFormValue({
        key: "scrumMasterId",
        value: selectedSprint?.scrumMasterId,
      })
    );
    dispatch(
      actions.updateFormValue({
        key: "startDate",
        value: selectedSprint?.startDate,
      })
    );
    dispatch(
      actions.updateFormValue({
        key: "endDate",
        value: selectedSprint?.endDate,
      })
    );
  };

  const renderMenuItem = (item: ISprintList) => {
    const { _id, endDate, startDate, name, members } = item;
    return (
      <div className="flex flex-col gap justify-center w-full" key={_id}>
        <div className=" flex gap-1 items-center truncate ">
          <img src={completed_icon} alt="completed_icon" className=" size-3 " />
          <span className=" text-sm font-medium text-black  truncate ">
            {name}
          </span>{" "}
          /{" "}
          <div className=" flex gap-1 items-center justify-center bg-gray-400 rounded px-1 h-4 ">
            <UserIcon size={12} />
            <span className="text-[10px] font-normal text-black ">
              {members?.length}
            </span>
          </div>
        </div>
        <div className="flex gap text-secondary text-[10px] font-normal ">
          {getSafeFormattedDate(startDate)} - {getSafeFormattedDate(endDate)} (
          {getWeekDifference(startDate, endDate)})
        </div>
      </div>
    );
  };
  return (
    <div ref={containerRef} className={`relative `}>
      <DropdownMenu.Root open={open} onOpenChange={setOpen}>
        <div className="flex flex-col gap-[6px]">
          <label className="text-xs font-normal text-secondary">
            Base on a sprint
          </label>
          <DropdownMenu.Trigger asChild>
            <div
              className={`flex items-center gap-[8px] flex-row border rounded-[4px] py-[16px] px-[10px] h-[48px]`}
            >
              <button className="flex items-center justify-between text-sm rounded w-full text-gray-700 leading-[21px] focus:outline-none placeholder:text-[#BDC0C3] placeholder:font-normal placeholder:text-sm placeholder:leading-[21px]">
                {selectedSprint ? (
                  renderMenuItem(selectedSprints)
                ) : (
                  <span className="font-normal text-sm text-black">
                    From scratch
                  </span>
                )}
                <div
                  className={`size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out ${
                    open ? "rotate-180" : ""
                  }`}
                >
                  <DropdownIcon size={16} />
                </div>
              </button>
            </div>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            align="start"
            sideOffset={5}
            side="bottom"
            style={{ width: dropdownWidth }}
            className={`bg-white shadow-lg rounded-md z-50 w-64 border border-[#E9ECF2]  py-2 `}
          >
            <div className={clsx("overflow-auto max-h-[270px] ")}>
              <DropdownMenu.Item
                onClick={() => {
                  onChangeDefault();
                }}
                className="h-[50px] flex w-full items-center gap-3 text-sm cursor-pointer hover:bg-gray-400 outline-none px-4"
              >
                <div className="flex flex-1 items-start gap-2">
                  <div className="flex flex-col">
                    <span
                      className={`text-sm leading-[21px] font-normal text-black `}
                    >
                      From scratch
                    </span>
                  </div>
                </div>

                {!selectedSprint && <CheckIcon color="#5A8DF1" />}
              </DropdownMenu.Item>
              <div className="h-[50px] flex w-full items-center gap-3 text-sm bg-gray-400 outline-none px-4">
                <span
                  className='text-sm font-normal text-black'
                >
                  Completed sprints
                </span>
              </div>
              {sprintList.length <= 0 && (
                <div className="h-[50px] flex w-full items-center justify-center outline-none px-4">
                  <span
                    className='text-sm font-normal text-center text-secondary'
                  >
                    ---- No sprint found ----
                  </span>
                </div>
              )}

              {sprintList.map((item) => {
                return (
                  <DropdownMenu.Item
                    onClick={() => {
                      onChange(item._id);
                    }}
                    className="h-[50px] flex w-full items-center gap-3 text-sm cursor-pointer hover:bg-gray-400 outline-none px-4"
                  >
                    {renderMenuItem(item)}

                    {selectedSprint === item._id && (
                      <CheckIcon color="#5A8DF1" />
                    )}
                  </DropdownMenu.Item>
                );
              })}
            </div>
          </DropdownMenu.Content>
        </div>
      </DropdownMenu.Root>
    </div>
  );
};

export default SelectSprint;
